import { atom } from 'recoil'

export const snackbarAtom = atom({
    key: 'snackbar',
    default: {
        open: false,
        message: '',
        severity: '' as 'success' | 'error' | ''
    }
})